module.exports = __webpack_public_path__ + "img/mp.b8706d9d.svg";